import React from "react";
import { useNavContext } from "../../context-api/nav-context";
import { Link } from "react-router-dom";

const NavbarMenu = () => {
  const {
    isMenuOpen,
    closeNavbarMenu,
    page: { linksOne, linksTwo, subtitle, subtitleTwo, articles },
  } = useNavContext();
  console.log("this state is", isMenuOpen);
  return (
    <div
      className={`${
        isMenuOpen ? "nav-bar-wrapper" : "nav-bar-wrapper hide-nav"
      }`}
    >
      <div
        className={`${
          isMenuOpen
            ? "navbar-menu__container"
            : "navbar-menu__container hide-nav"
        }`}
      >
        <div className="navbar-menu__card">
          <div className="navbar-menu__card-section-small">
            <h4 className="navbar-menu__card-subtitle">{subtitle}</h4>
            <div>
              <ul className="navbar-menu__card-list">
                {linksOne.map((item, index) => {
                  const { label, icon, url } = item;
                  return (
                    <Link
                      to={url}
                      onClick={closeNavbarMenu}
                      className="navbar-menu_card--link"
                    >
                      {icon} {label}
                    </Link>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="navbar-menu__card-section-small">
            <h4 className="navbar-menu__card-subtitle">{subtitleTwo}</h4>
            <div className="featured-img-wrapper">
              <div className="featured-img-bottom">
                {linksTwo.map((item, index) => {
                  const { image } = item;
                  return (
                    <div key={index} className="gas-safe-img">
                      <img src={image} alt="" />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="navbar-menu__card-section-articles">
            {/* Articles Card Start */}
            {articles.map((item) => {
              const { image, subtitle, title, url } = item;
              return (
                <div className="navbar-menu__card-article-container">
                  <div className="navbar-menu__card-article-header">
                    <img src={image} alt="" />
                  </div>
                  <div className="navbar-menu__card-article-body">
                    <h5 className="navbar-menu__card-body-subtitle">
                      {subtitle}
                    </h5>
                    <h4 className="navbar-menu__card-body-title">
                      <Link
                        to={url}
                        onClick={closeNavbarMenu}
                        className="navbar-menu_card--link"
                      >
                        {title}
                      </Link>
                    </h4>
                  </div>
                </div>
              );
            })}
            {/* Articles Card End */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavbarMenu;
